import biome from './biome.png'
import food from './food.png'
import test from './test.png'
import biome_mob from './biome_mob.png'
import food_mob from './food_mob.png'
import test_mob from './test_mob.png'

export const imgMap = {
  1: biome,
  2: food,
  3: test,
}

export const imgMapMob = {
  1: biome_mob,
  2: food_mob,
  3: test_mob,
}
